import { render, staticRenderFns } from "./PowerBiEmbed.vue?vue&type=template&id=b5049718&scoped=true"
import script from "./PowerBiEmbed.vue?vue&type=script&lang=js"
export * from "./PowerBiEmbed.vue?vue&type=script&lang=js"
import style0 from "./PowerBiEmbed.vue?vue&type=style&index=0&id=b5049718&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5049718",
  null
  
)

export default component.exports